export const arrayToChunks = <T>(array: T[], chunkSize: number) => {
  const chunkResults: T[][] = [];
  const size = Math.max(...[chunkSize, 1]);
  for (let i = 0; i < array.length; i += size) {
    const chunk = array.slice(i, i + size);
    chunkResults.push(chunk);
  }
  return chunkResults;
};

// if item exists in array, remove it.
// if item does not exist in array, add it
export const toggleStringInArray = (str: string, arr: string[] | undefined) => {
  if (arr === undefined) {
    return [str];
  } else {
    if (arr.includes(str)) {
      return [...arr].filter((arrStr) => arrStr !== str);
    } else {
      const arrWithNewString = [...arr];
      arrWithNewString.push(str);
      return arrWithNewString;
    }
  }
};

// Type guard to use with `Array.filter()` to filter out null values from an array
export const removeNulls = <T>(value: T | null): value is T => value !== null;

/**
 * Sorts an array of strings alphabetically, case-insensitive.
 */
export const sortStringInArray = (
  arr: string[] | null | undefined,
): string[] => {
  if (!Array.isArray(arr)) return [];
  return [...arr].sort((a, b) =>
    a.localeCompare(b, 'en-US', { sensitivity: 'base' }),
  );
};

export const reduceToMap = <T>(arr: { key: string; value: T }[]) => {
  return arr.reduce<Record<string, { key: string; value: T } | undefined>>(
    (acc, { key, value }) => {
      acc[key] = { key, value };
      return acc;
    },
    {},
  );
};
